//---------------------------------------------------------------------------------------------
// Description
// Kentico Helper Module for AtlasRTX
// Initialization code runs on every Kentico page as it's part of the app.js.
// The code adds a window.atlasSettings object to the site with different parameters/metadata
// depending on the page type.  See https://jfshea.atlassian.net/browse/KWM-3063
//---------------------------------------------------------------------------------------------
import $ from 'jquery';

import SheaHomesServiceApi from './sheahomesapi-service';
export function AtlasRTXHelper()
{
    var obj = {
        init: rebuildData,
        createScriptElement: createScriptElement,
        rebuildData: rebuildData,
        pageData: {},
        atlasData: {
            mode: "",
            params: {
                state: "",
                areaName: "",
            }
        },
        getPageData: getPageData,
        buildAtlasData: buildAtlasData,
        setAtlasSettings: setAtlasSettings,
        setChatBubblePosition: setChatBubblePosition
    };
    obj.CHAT_POSITION = 100;
    return obj;

    // See FYHFilterAndResults.ascx
    // rebuildData() is called after the user selects new state/region
    function rebuildData()
    {
        obj.getPageData();
        if (obj.buildAtlasData())
        {
            obj.setAtlasSettings(); // makes call to setChatBubblePosition() and createScriptElement()
        }
        else
        {
            obj.setChatBubblePosition();
            obj.createScriptElement();
        }
    }

    // Master Template expected to have <id="non-production-atlasrtx"> or <id="production-atlasrtx">
    // This function adds a <script id="atlasrtx-script"> element before the above element
    // The src= changes from the non-production to the production script url depending on which
    // element exists <id="non-production-atlasrtx"> or <id="production-atlasrtx">
    function createScriptElement()
    {
        var productionAtlasRTX = document.getElementById("production-atlasrtx");
        var nonProductionAtlasRTX = document.getElementById("non-production-atlasrtx");
        var existingScript = document.getElementById("atlasrtx-script");
        if (nonProductionAtlasRTX != null)
        {
            var scriptSrc = nonProductionAtlasRTX.getAttribute("script-src");
            if (scriptSrc) {
                if (existingScript) {
                    existingScript.remove();
                }
                var atlasScriptTag = document.createElement('script');
                atlasScriptTag.id = "atlasrtx-script";
                atlasScriptTag.async = true;
                atlasScriptTag.src = scriptSrc;
                nonProductionAtlasRTX.parentNode.insertBefore(atlasScriptTag, nonProductionAtlasRTX);
            } else {
                console.error('element id="non-production-atlasrtx" is missing script-src attribute.');
            }
        }
        else if (productionAtlasRTX != null)
        {
            var scriptSrc = productionAtlasRTX.getAttribute("script-src");
            if (scriptSrc) {
                if (existingScript) {
                    existingScript.remove();
                }
                var atlasScriptTag = document.createElement('script');
                atlasScriptTag.id = "atlasrtx-script";
                atlasScriptTag.async = true;
                atlasScriptTag.src = scriptSrc;
                productionAtlasRTX.parentNode.insertBefore(atlasScriptTag, productionAtlasRTX);
            } else {
                console.error('element id="production-atlasrtx" is missing script-src attribute.');
            }
        }
    }

    function getPageData()
    {
        if (window.dataLayer && window.dataLayer.length > 0)
        {
            var names = ["brand", "breadcrumb", "city", "community", "dma", "model", "pageType", "state", "model", "listingId", "areaName", "specNumber"];
            window.dataLayer.forEach(elem => {
                if (elem.pageType || elem.type == "fyh-search")
                {
                    names.forEach(name => {
                        // The FYH module adds a dataLayer object with
                        // type==fyh-search.  The data for this module is
                        // stored in elem.params instead of elem
                        if (elem.type == "fyh-search")
                        {
                            if (elem["params"][name])
                            {
                                obj.pageData[name] = elem["params"][name];
                            }
                            // Manually set the page type for the Find Your Home page
                            obj.pageData.pageType = "SHM.FindYourHome";
                        }
                        else {
                            if (elem[name])
                            {
                                obj.pageData[name] = elem[name];
                            }
                        }
                    })
                }
            });
            if (obj.pageData["community"])
            {
                obj.pageData["community"] = obj.pageData["community"].replace(/[^0-9a-zA-Z ]+/,'');
            }
        }
    }

    function buildAtlasData()
    {
        switch (obj.pageData.pageType)
        {
            // Home Page
            case "SHM.BasePage":
                return false;

            // Community mode
            case "SHM.Community":
            {
                obj.atlasData.mode = "community";
                obj.atlasData.params = {
                    communityName: obj.pageData.community
                }
            };
            break;

            // Plan mode
            case "SHM.Plan":
            {
                obj.atlasData.mode = "floorplan";
                obj.atlasData.params = {
                    communityName: obj.pageData.community,
                    planName: obj.pageData.model
                }
            };
            break;

            // Spec mode
            case "SHM.InventoryHome":
            {
                obj.atlasData.mode = "spec";
                obj.atlasData.params = {
                    communityName: obj.pageData.community,
                    planName: obj.pageData.model,
                    specNumber: obj.pageData.specNumber,                    
                }
            };
            break;

            // State
            case "SHM.State":
            {
                {
                    obj.atlasData.mode = "search";
                    obj.atlasData.params = {
                        state: obj.pageData.state,
                    }
                }
            }
            break;

            // Market Area
            case "SHM.MarketArea":
            {
                obj.atlasData.mode = "search";
                obj.atlasData.params = {
                    state: obj.pageData.state,
                    areaName: obj.pageData.dma                 
                }
            }
            break;

            // Master Plan
            case "SHM.MasterPlan":
            {
                obj.atlasData.mode = "search";
                obj.atlasData.params = {
                    city: obj.pageData.city,
                    community: obj.pageData.community,
                    state: obj.pageData.state,
                    areaName: obj.pageData.dma
                }
            }
            break;
            
            // City
            case "SHM.City":
            {
                obj.atlasData.mode = "search";
                obj.atlasData.params = {
                    city: obj.pageData.city,
                    areaName: obj.pageData.dma,
                    state: obj.pageData.state
                }
            }
            break;                
  
            // Find Your Home
            case "SHM.FindYourHome":
            {
                // On the Find Your Home (FYH) Page,
                // The two hiiden elements region and state is set
                // with the "Change" button and modal state/region selector
                var state = $("#state").val();
                var region = $("#region").val();
                let urlParams = new URLSearchParams(location.search);

                obj.atlasData.mode = "search";
                obj.atlasData.params = {
                }
                if (state != "any" && state != "") {
                    obj.atlasData.params.state = decodeURIComponent(state);
                }
                if (region != "any" && region != '' && !urlParams.has("regions")) {
                    shApiService.lookupDocumentByNodeGUID(region, responseCallback);
                    return false;
                }
            }
            break;

            default:
                return false;
        }
        return true;
    }

    function setAtlasSettings()
    {
        // Create window.atlasSettings if needed
        if (window.atlasSettings == undefined) {
            window.atlasSettings = {};
        }

        obj.setChatBubblePosition();

        // Create rtxContext if needed
        if (window.atlasSettings.rtxContext == undefined) {
            window.atlasSettings.rtxContext = {};
        }
        window.atlasSettings.rtxContext.mode = obj.atlasData.mode;
        window.atlasSettings.rtxContext.params = obj.atlasData.params;

        obj.createScriptElement();
    }

    function setChatBubblePosition()
    {
        // Create window.atlasSettings if needed
        if (window.atlasSettings == undefined) {
            window.atlasSettings = {};
        }
        
        // Set bubble position
        if (obj.CHAT_POSITION > 0)
        {
            if (window.atlasSettings.display == undefined) {
                window.atlasSettings.display = {};
            }
            window.atlasSettings.display.bottom = obj.CHAT_POSITION;
        }
    }

    function responseCallback(rsp)
    {
        if (rsp.Success)
        {
            obj.atlasData.params.areaName = rsp.Document.DocumentName;
            obj.setAtlasSettings();
        }
    }
};
// window.atlasRTXHelper = AtlasRTX();
// window.atlasRTXHelper.init();
// console.log(atlasRTXHelper);
// console.log(atlasSettings);

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------
$(window).on('load', function ()
{
    if (window.shApiService == undefined)
    {
        window.shApiService = SheaHomesServiceApi();
    }
    window.atlasRTXHelper = AtlasRTXHelper();
    // delay loading of JS for window.JS_LOAD_DELAY_DURATION amount of time for performance reasons
    setTimeout(() => window.atlasRTXHelper.init(), window.JS_LOAD_DELAY_DURATION);
});
